import React from "react";
import ReportList from "./ReportList";

const DashboardReport = () => {
  return <ReportList />;
};

export default DashboardReport;
